import { PublicClientApplication, Configuration } from "@azure/msal-browser";

const tenantId = `${process.env.REACT_APP_TENANT_ID}`;
const applicationID = `${process.env.REACT_APP_CLIENT_ID}`;
const reactRedirectUri = window.location.origin + '/home';
const scope = `${process.env.REACT_APP_SCOPE}`;

const msalConfig: Configuration = {
  auth: {
    clientId: applicationID,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: reactRedirectUri,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: [
    "api://c123a8e7-7036-4c2a-805e-9c5981390151/access_as_user",
    "openid",
    "offline_access"
  ]
};

const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.initialize().then(() => {  
});

export default msalInstance;
